import type { Layer, LayerStyle } from '@pn/core/domain/layer';
import {
  generatePointsLayer,
  getPointsLayerId,
  getSelectedLayerId,
} from '@pn/core/domain/workspace';
import {
  mapboxLayerMapper,
  POINTS_LAYER_MIN_ZOOM,
} from '@pn/services/map/mapbox/mappers/mapboxLayerMapper';

const isSelectedExpr = ['==', ['feature-state', 'isSelected'], true] as const;

export function buildPointsLayers(params: {
  layer: Layer;
  pointsSourceId: string;
  selectionStyle: LayerStyle;
}): mapboxgl.AnyLayer[] {
  const { layer, pointsSourceId, selectionStyle } = params;

  const pointsLayer: Layer = {
    ...generatePointsLayer(layer),
    source: pointsSourceId as any,
  };

  const selectionPointsLayer: Layer = {
    ...generatePointsLayer(layer),
    id: getSelectedLayerId(getPointsLayerId(layer.id)),
    source: pointsSourceId as any,
    style: {
      color: selectionStyle.color,
      strokeWidth: 1,
      strokeColor: '#000',
      radius: 8,
      opacity: ['case', isSelectedExpr, 1, 0],
      strokeOpacity: ['case', isSelectedExpr, 1, 0],
    },
  };

  return [
    {
      ...mapboxLayerMapper.toTargetLayer(pointsLayer),
      maxzoom: POINTS_LAYER_MIN_ZOOM,
    } as mapboxgl.AnyLayer,
    {
      ...mapboxLayerMapper.toTargetLayer(selectionPointsLayer),
      maxzoom: POINTS_LAYER_MIN_ZOOM,
    } as mapboxgl.AnyLayer,
  ];
}
